import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom, of } from "rxjs";
import { catchError, defaultIfEmpty, filter, tap } from "rxjs/operators";

import { applyEnvironmentConfig } from "../environments/environment";
import { RuntimeConfig } from "../environments/environment.shared";

@Injectable({ providedIn: "root" })
export class RuntimeConfigService {
  // Canonical runtime override file expected at app web root.
  // Deploy scripts are responsible for placing the environment-specific content
  // under this filename.
  private static readonly RUNTIME_CONFIG_URL = "runtime-config.json";
  private readonly http = inject(HttpClient);

  // Invoked via APP_INITIALIZER so runtime host overrides are applied before
  // application bootstrap completes.
  loadConfig(): Promise<void> {
    return firstValueFrom(
      this.http
        .get<RuntimeConfig | null>(RuntimeConfigService.RUNTIME_CONFIG_URL)
        .pipe(
          catchError((error) => {
            // Fail-open: continue with built-in defaults when the runtime file
            // is missing or unreadable, while keeping diagnostic context.
            console.warn(
              `[RuntimeConfigService] Unable to load ${RuntimeConfigService.RUNTIME_CONFIG_URL}. Continuing with environment defaults.`,
              error,
            );
            return of(null);
          }),
          filter((config): config is RuntimeConfig => config !== null),
          tap((config) => applyEnvironmentConfig(config)),
          defaultIfEmpty(null),
        ),
    ).then(() => {});
  }
}

export function runtimeConfigInitializer(): Promise<void> {
  return inject(RuntimeConfigService).loadConfig();
}
